import { Language } from './locales';

/**
 * Formats a day offset as localized relative time with correct plural forms,
 * e.g. 1 → "tomorrow" / "zítra", 3 → "in 3 days" / "za 3 dny".
 */
export function formatRelativeDays(days: number, language: Language): string {
  return new Intl.RelativeTimeFormat(language, { numeric: 'auto' }).format(days, 'day');
}
